import React from 'react';

import './index.pc.scss';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcModalBack from 'components/molecules/PcModalBack';
import PcAccordionCheckBox from 'components/molecules/PcAccordionCheckBox';
import PcAccordionRadioTextArea from 'components/molecules/PcAccordionRadioTextArea';
import PcInputItem from 'components/molecules/PcInputItem';
import PcSuggestList from 'components/molecules/PcSuggestList';
import PcErrorArea from 'components/molecules/PcErrorArea';
import RadioInput from 'components/atoms/Input/RadioInput';
import BasicCheckBoxInput from 'components/atoms/Input/BasicCheckBoxInput';
import TextAreaInput from 'components/atoms/Input/TextAreaInput';
import TextInput from 'components/atoms/Input/TextInput';

const PresentPC = ({
  workCategory,
  workCategoryOtherDetail,
  workDetailText,
  employmentPlacementDispatching,
  companyNameText,
  dept,
  chargePersonNameText,
  tel,
  email,
  address,
  ekiName,
  ekiSuggestNames,

  // 表示リスト
  WorkCategoryList,

  // onChange
  onChangeWorkCategory,
  onChangeWorkCategoryOtherDetail,
  onChangeWorkDetailText,
  onChangeEmploymentPlacementDispatching,
  onChangeCompanyNameText,
  onChangeDept,
  onChangeChargePersonNameText,
  onChangeTel,
  onChangeEmail,
  onChangeAddress,
  onChangeEkiname,

  modalBackIsEnable,

  // onClick
  onClickMainButton,
  onClickEkiSuggest,

  // 入力チェック
  valid,
  errorDispMap,
  isApiError,
  showLoading,
}) => (
  <div className="Input PC">
    <PcBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      isApiError={isApiError}
      showLoading={showLoading}
    >

      <span>
        <PcInputItem 
          title="ご検討の職種"
          label='必須'
          questionMark
          popUpTitle="職種について"
          popUpDetail={(
            <span>
              <p>法律上の派遣禁止業務（港湾運送・建設・警備・医療・士業）や製造業務等、一部の業務は弊社のサービスの対象外となる可能性がございます。</p>
            </span>
          )}
        >
            
          <span>
            {WorkCategoryList.dataList.map((data)=>{
              if(data.value === 'A' || data.value === 'B' || data.value === 'C' ){
                return(                            
                  <div className="mB10" key={data.label}>
                    <PcAccordionCheckBox
                      id={data.value}
                      value={data.value}
                      label={data.label}
                      onChange={onChangeWorkCategory}
                      checked={workCategory === data.value}

                      title='職種を選択してください'
                      list={WorkCategoryList.checkList[data.value]}
                      require='必須'
                    />
                  </div>
                );
              } 
              if(data.value === 'D'){
                return(
                  <div className="mB10 fB" key={data.label}>
                    <RadioInput
                      id={data.value}
                      value={data.value}
                      label={data.label}
                      onChange={onChangeWorkCategory}
                      checked={workCategory === data.value}
                    />
                  </div>
                );
              }
              if(data.value === 'E'){
                return(
                  <div key={data.label}>
                    <PcAccordionRadioTextArea
                      id={data.value}
                      value={data.value}
                      label={data.label}
                      RadioOnChange={onChangeWorkCategory}
                      checked={workCategory === data.value}

                      name=''
                      textAreaValue={workCategoryOtherDetail}
                      cmntOnChange={onChangeWorkCategoryOtherDetail}
                      maxLength='500'
                      placeholder=''
                      rows='10'
                      cols='30'
                      wordCount='(500文字以下)'

                      require='任意'
                    />
                    <span className='INPUT_ERR'>
                      <PcErrorArea position='relative' message={errorDispMap.workCategoryOtherDetail} />
                    </span>
                  </div>
                );
              }
              return '';
            })}
          </span>
        </PcInputItem>
      </span>

      <span className="workDetailText">
        <PcInputItem
          title='お仕事内容の詳細'
          label='任意'
          questionMark
          popUpTitle=""
          popUpDetail={(
            <span>
              <p>
                例）
                <br />
                期間：20xx年4月1日より1年間
                <br />
                人数：2名
                <br />
                勤務時間：9時～17時、週5日勤務（土日祝休み）
                <br />
                残業：5~10時間／月（繁忙期10~20時間／月）
                <br />
                必要スキル：Excelで表、グラフが作成できる方
                <br />
              </p>
            </span>
          )}
        >
          <span>
            <TextAreaInput 
              name='workDetailText' 
              value={workDetailText} 
              onChange={onChangeWorkDetailText} 
              maxLength='500' 
              // inValid={!!errorDispMap.workDetailText}
              suggestText={false}
            />
            <div className='word-count'>(500文字以下)</div>
            <PcErrorArea position='relative' message={errorDispMap.workDetailText} />
          </span>
        </PcInputItem>
      </span>
      
      <span className="employmentPlacementDispatching">
        <PcInputItem
          title='紹介予定派遣の希望'
          label='任意'
          questionMark
          popUpTitle='紹介予定派遣について'
          popUpDetail={(
            <span>
              <p>
                「紹介予定派遣」とは、社員として採用することを前提に、派遣社員を一定期間受入、派遣期間中に社員としての適性を見極めることができる仕組みです。
                <br />
                <br />
                詳細は
                <a className="link-grey" href="/sol/contents/client/ttoh/" target="_blank" rel="noopener noreferrer">こちら</a>
              </p>
            </span>
          )}
        >
          <span>
            <BasicCheckBoxInput 
              id={employmentPlacementDispatching}
              value={employmentPlacementDispatching}
              label="紹介予定派遣のみをご希望の方はこちらをチェックしてください"
              onChange={onChangeEmploymentPlacementDispatching}
              checked={employmentPlacementDispatching}
            />
          </span>
        </PcInputItem>
      </span>

      <span>
        <PcInputItem
          title='企業名'
          label='必須'
          questionMark={false}
        >
          <span>
            <TextInput
              name='companyNameText'
              val={companyNameText}
              onChange={onChangeCompanyNameText} 
              placeholder='株式会社リクルートスタッフィング'
              maxLength='300'
              inValid={!!errorDispMap.companyNameText}
              suggestText={false}
            />
            <PcErrorArea message={errorDispMap.companyNameText} />
          </span>
        </PcInputItem>

      </span>

      <span>
        <PcInputItem
          title='派遣先部課名'
          label='必須'
          questionMark
          popUpTitle=""
          popUpDetail={(
            <span>
              派遣先部課名がない場合は「なし」と入力してください
            </span>
          )}
        >
          <TextInput 
            name='dept' 
            val={dept} 
            onChange={onChangeDept} 
            placeholder='人事部　人事課'
            maxLength='150'
            inValid={!!errorDispMap.dept}
          />
        </PcInputItem>
        <PcErrorArea position='relative' message={errorDispMap.dept} />
      </span>
      <span>
        <PcInputItem
          title='ご担当者名'
          label='必須'
          questionMark={false}
        >
          <TextInput 
            name='chargePersonNameText' 
            val={chargePersonNameText} 
            onChange={onChangeChargePersonNameText} 
            placeholder='派遣　太郎'
            maxLength='150'
            inValid={!!errorDispMap.chargePersonNameText}
          />
        </PcInputItem>
        <PcErrorArea position='relative' message={errorDispMap.chargePersonNameText} />
      </span>

      <span>
        <PcInputItem 
          title='電話番号'
          label='必須'
          questionMark={false}
        >
          <TextInput
            name='tel'
            val={tel}
            onChange={onChangeTel}
            placeholder='090123456789'
            maxLength='13'
            inValid={!!errorDispMap.tel}
          />
        </PcInputItem>
        <PcErrorArea position='relative' message={errorDispMap.tel} />
      </span>

      <span>
        <PcInputItem 
          title='メールアドレス'
          label='必須'
          questionMark={false}
        >
          <TextInput 
            name='email'
            val={email}
            onChange={onChangeEmail}
            placeholder='haken@r-staffing.co.jp'
            inValid={!!errorDispMap.email}
          />
        </PcInputItem>
        <PcErrorArea position='relative' message={errorDispMap.email} />
      </span>

      <span>
        <PcInputItem 
          title='派遣先住所'
          label='必須'
          questionMark
          popUpTitle=""
          popUpDetail={(
            <span>
              <p>
                下記エリアはサービス対象外となりますのでご了承ください。
                <br />
                青森県・山形県・新潟県・長野県・山梨県・富山県・石川県・福井県・鳥取県・島根県・岡山県・山口県・和歌山県・愛媛県・高知県・徳島県・香川県・長崎県・大分県・宮崎県・鹿児島県・沖縄県
              </p>
            </span>
          )}
        >
          <TextInput 
            name='address'
            val={address}
            onChange={onChangeAddress}
            placeholder='都道府県・市区町村・丁目番地・ビル名'
            maxLength='300'
            inValid={!!errorDispMap.address}
          />
        </PcInputItem>

        <div className='address'>
          <PcErrorArea position='relative' message={errorDispMap.address} />
          <div className='example'>（例）東京都千代田区有楽町1‐13‐1　スタッフィングビル19F</div>          
        </div>
      </span>

      <span>
        <PcInputItem
          title='派遣先最寄り駅'
          label='必須'
          questionMark={false}
        >
          <span>
            <TextInput
              name='ekiName'
              val={ekiName}
              onChange={onChangeEkiname}
              placeholder='駅名'
              inValid={!!errorDispMap.ekiName}
              suggestText
            />
            <PcErrorArea message={errorDispMap.ekiName} />
            {/* 駅サジェストエリア */}
            <div className="searchNamesWrapper">
              <div className="searchNames">
                <PcSuggestList
                  items={ekiSuggestNames.map(x => x.ekiNm)}
                  onClick={onClickEkiSuggest}
                  fullWidth
                />
              </div>
            </div>
          </span>
        </PcInputItem>
      </span>
      <PcModalBack
        modalBackIsEnable={modalBackIsEnable}
      />
    </PcBasicTemplate>
  </div>
);

export default PresentPC;